import { selectRootSliceLPR } from '../../Main/selectors';
import { ROOT_SLICE, sanitizeToggleState, TOGGLE_STATES } from './constants';

const EMPTY_ARRAY = [];

export const selectThisSlice = state => { 
  const slice = selectRootSliceLPR(state);
  if (slice[ROOT_SLICE]) { 
    return slice[ROOT_SLICE];
  }

  // else assume state is already LAFDateRange.
  return state;
};

export const selectCountExistingReports = state => { 
  const slice = selectThisSlice(state);
  return slice.countExistingReports;
}

export const selectCountGhostReports = state => {
	const slice = selectThisSlice(state);
	return slice.countGhostReports;
};

export const selectCounts = state => {
	const slice = selectThisSlice(state);
	const { countExistingReports, countGhostReports } = slice;
	return { countExistingReports, countGhostReports };
};

export const selectToggleState = state => {
	const slice = selectThisSlice(state);
	return sanitizeToggleState(slice.toggleState);
};

export const selectRefReportAggs = state => {
	const slice = selectThisSlice(state);
	return slice.refReportAggs || EMPTY_ARRAY;
};

export const selectIsActive = state => {
	const toggleState = selectToggleState(state);
	return [TOGGLE_STATES.EXISTING, TOGGLE_STATES.GHOST].indexOf(toggleState) > -1;
}
